import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function testId(baseId: string, ...suffixes: string[]) {
  if (!baseId) throw new Error('baseId cannot be an empty string');

  const testIdParts = [baseId];

  for (const idx in suffixes) {
    testIdParts.push(suffixes[idx]);
  }

  return { 'data-testid': testIdParts.join('+') };
}
